import React from 'react';
import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import groupBy from 'lodash/groupBy';
import adobe from '../static/adobe.svg';
import delhigovt from '../static/delhigovt.svg';
import delhi from '../static/delhi.png';
import india from '../static/india.png';
import OtherLinks from './OtherLinks';
import Footer from './Footer';
import NewWindowLink from "./NewWindowLink";
import {EXTERNAL_URLS} from "../constants";

const initialState = { stats: {}, isLoading: true };

class CovidDelData extends React.Component {
  state = initialState
  componentDidMount() {
    // eslint-disable-next-line react/no-unused-state
    fetch('https://nctdelhi.blob.core.windows.net/nctdelhi/stats2.json').then((result) => result.json()).then((result) => this.setState({ stats: groupBy(result, 'type'), isLoading: false }, /* NOT DIRECTLY KEYED BECAUSE TESTING TYPE IS DUPLICATED, HENCE GROUPED BY INSTEAD */ () => console.log(this.state)));
  }

  render() {
    const {
      stats,
    } = this.state;
    let {
      state = [],
      national = [],
      district = [],
    } = stats;
    const {
      testingall = [],
      testingdaily = [],
    } = stats;
    district = keyBy(district, 'name');
    // eslint-disable-next-line prefer-destructuring
    state = state[0];
    // eslint-disable-next-line prefer-destructuring
    national = national[0];
    const testingDaily = testingdaily[0];
    const testingAll = testingall[0];
    // TODO: THIS IS NOT PRETTY, FIX THIS - Aman

    return (
      <div>
        <main>
          <div className="maintitlebar">
            <h1>Delhi Covid Updates</h1>
            <img className="delhi-govt-logo" src={delhigovt} style={{ height: '70px' }} />
          </div>
          <div id="main--sections">
            <div id="updates">
              <div className="update--parent">
                <div className="update--item">
                  <div className="update--title">India Covid Cases</div>
                  <div className="update--container">
                     <img className="update--stats_map" src={india} />
                  <div className="update--confirmed">
                    <div>Confirmed</div>
                    {get(national, 'confirmed', '-')}
                  </div>
                  <div className="update--stats">
                   
                    <div className="stats--active">
                      <div>Active</div>
                      {get(national, 'active', '-')}
                    </div>
                    <div className="stats--recovered">
                      <div>Recovered</div>
                      {get(national, 'recovered', '-')}
                    </div>
                    <div className="stats--deaths">
                      <div>Deaths</div>
                      {get(national, 'deaths', '-')}
                    </div>
                    </div>
                  </div>
                  <div className="update--source">Source: MoHFW, GoI</div>
                </div>
                <div className="update--item">
                
                  <div className="update--title">Delhi Covid Cases</div>
                  <div className="update--container"> 
                   <img className="update--stats_map" src={delhi} />
                  <div className="update--confirmed">
                    <div>Confirmed</div>
                    {get(state, 'confirmed', '-')}
                  </div>
                  <div className="update--stats">
                    <div className="stats--active">
                      <div>Active</div>
                      {get(state, 'active', '-')}
                    </div>
                    <div className="stats--recovered">
                      <div>Recovered</div>
                      {get(state, 'recovered', '-')}
                    </div>
                    <div className="stats--deaths">
                      <div>Deaths</div>
                      {get(state, 'deaths', '-')}
                    </div>
                    </div>
                  </div>
                  <div className="update--source">Last Updated: {get(state, 'month', '-')} {get(state, 'day', '-')}, {get(state, 'year', '-')}</div>
                </div>
                <div className="update--item">
                  <div className="update--title ">Tests Conducted In Delhi</div>
                <div className="update--container "> 
                  
                  
                  <img className="update--stats_map" src={delhi} />
                  <div className="teststoday">
                    <div>Tests Today</div>
                    {get(testingDaily, 'confirmed', '-')}
                  </div>
                  <div className="testsconducted">
                    <div>Total Tests Conducted</div>
                    {get(testingAll, 'confirmed', '-')}
                  </div>
                  </div>
                  <div className="update--source">Last Updated: {get(testingDaily, 'month', '-')} {get(testingDaily, 'day', '-')}, {get(testingDaily, 'year', '-')}</div>
                </div>
              </div>
              {/*<div className="update--parent">
                <div id="mapviz">
                  <div id="districtdata">
                    <h5 style={{ marginBottom: '10px' }}>District Data</h5>
                    <ul>
                      <li>New Delhi<span className="districtdata--number">{get(district, 'new delhi.confirmed', '-')}</span></li>
                      <li>North West<span className="districtdata--number">{get(district, 'north west.confirmed', '-')}</span></li>
                      <li>North<span className="districtdata--number">{get(district, 'north.confirmed', '-')}</span></li>
                      <li>West<span className="districtdata--number">{get(district, 'west.confirmed', '-')}</span></li>
                      <li>South West<span className="districtdata--number">{get(district, 'south west.confirmed', '-')}</span></li>
                      <li>South<span className="districtdata--number">{get(district, 'south.confirmed', '-')}</span></li>
                      <li>South East<span className="districtdata--number">{get(district, 'south east.confirmed', '-')}</span></li>
                      <li>Central<span className="districtdata--number">{get(district, 'central.confirmed', '-')}</span></li>
                      <li>North East<span className="districtdata--number">{get(district, 'north east.confirmed', '-')}</span></li>
                      <li>Shahdara<span className="districtdata--number">{get(district, 'shahdara.confirmed', '-')}</span></li>
                      <li>East<span className="districtdata--number">{get(district, 'east.confirmed', '-')}</span></li>
                    </ul>
                     eslint-disable-next-line max-len
                     <div className="update--source" style={{ marginTop: '15px' }}>
                    Last updated: April 27, 2020</div>
                     TODO: DO NOT HAVE A DISTRICT LEVEL UPDATE YET,
                    INSTRUCTIONS UNCLEAR ON HOW TO DO THIS
                  </div>
                  <div id="map">
                    <iframe src="https://www.google.co.in/maps/d/embed?mid=1x-pGYJcJZZ9Nn3OnRNpXAeU_nPhQs_3i" width="100%" height="500" />
                  </div>
                </div>
              </div>
              <div id="datasource">Source: Health Department, GNCTD</div>*/}
            </div>
            <div>
              <div className="asideComponent">
                <h6>Downloads</h6>
                <NewWindowLink url={EXTERNAL_URLS.delhiHealthBulletin}><div className="asideComponentItem"><img src={adobe} style={{ marginRight: '8px' }} />Delhi Health Bulletin</div></NewWindowLink>
              </div>
              <OtherLinks />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }
}

export default CovidDelData;
